import { render } from "./production.vue?vue&type=template&id=045ef10a"
import script from "./production.vue?vue&type=script&lang=js"
export * from "./production.vue?vue&type=script&lang=js"

import "./production.vue?vue&type=style&index=0&id=045ef10a&lang=css"
script.render = render

export default script